// extracted by mini-css-extract-plugin
module.exports = {"banner":"RecapBanner_banner__4574w","text":"RecapBanner_text__4aBju","full":"RecapBanner_full__Ubvuq"};